module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Status/images/gold_left_1.8a2dbe3c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Status/images/gold_left_1.png
// module id = 2859
// module chunks = 11